import React, { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { businessInfo } from "../mock";
import ViberButton from "./ViberButton";

const defaultMessage = encodeURIComponent(
  "Γεια σας! Επισκέφτηκα την ιστοσελίδα σας και θέλω πληροφορίες για επισκευή."
);

const stripPhone = (p) => p.replace(/[^0-9]/g, "");

const WhatsAppButton = () => {
  const [open, setOpen] = useState(false);
  const primaryPhone = stripPhone(businessInfo.mobile);
  const secondaryPhone = stripPhone(businessInfo.mobile2);

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-row items-end gap-3">
      <ViberButton />
      <div className="flex flex-col items-end gap-3">
      {open && (
        <div className="pcb-card p-4 w-72 shadow-2xl animate-in fade-in slide-in-from-bottom-2 duration-200">
          <div className="flex items-start justify-between gap-3">
            <div>
              <div className="text-white font-semibold">Επικοινωνήστε μαζί μας</div>
              <div className="text-xs text-emerald-100/60 mt-0.5">
                Απαντάμε άμεσα 24/7
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-emerald-300/70 hover:text-white p-1"
              aria-label="close"
            >
              <X className="w-4 h-4" />
            </button>
          </div>

          <div className="mt-4 space-y-2">
            <a
              href={`https://wa.me/30${primaryPhone}?text=${defaultMessage}`}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 rounded-md border border-emerald-500/40 bg-emerald-500/10 hover:bg-emerald-500/20 transition-colors px-3 py-2.5"
            >
              <div className="w-9 h-9 rounded-full bg-[#25D366] flex items-center justify-center shrink-0">
                <MessageCircle className="w-5 h-5 text-white" />
              </div>
              <div className="text-left">
                <div className="text-xs text-emerald-300/80">WhatsApp 1</div>
                <div className="text-sm text-white font-medium">
                  {businessInfo.mobile}
                </div>
              </div>
            </a>
            <a
              href={`https://wa.me/30${secondaryPhone}?text=${defaultMessage}`}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 rounded-md border border-emerald-500/40 bg-emerald-500/10 hover:bg-emerald-500/20 transition-colors px-3 py-2.5"
            >
              <div className="w-9 h-9 rounded-full bg-[#25D366] flex items-center justify-center shrink-0">
                <MessageCircle className="w-5 h-5 text-white" />
              </div>
              <div className="text-left">
                <div className="text-xs text-emerald-300/80">WhatsApp 2</div>
                <div className="text-sm text-white font-medium">
                  {businessInfo.mobile2}
                </div>
              </div>
            </a>
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((s) => !s)}
        aria-label="WhatsApp"
        className="relative w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] transition-colors flex items-center justify-center shadow-lg shadow-emerald-900/40 group"
      >
        <MessageCircle className="w-7 h-7 text-white" />
        {!open && (
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        )}
      </button>
      </div>
    </div>
  );
};

export default WhatsAppButton;
